import React from "react"
import RateBuilderGeneral from "./tabs/RateBuilderGeneral"
import RateBuilderBillingPolicy from "./tabs/RateBuilderBillingPolicy"
import RateBuilderGuestTypes from "./tabs/RateBuilderGuestTypes"
import RateBuilderProducts from "./tabs/RateBuilderProducts"
import RateBuilderSeasonalRates from "./tabs/RateBuilderSeasonalRates"
import RateBuilderRoomTypes from "./tabs/RateBuilderRoomTypes"
import RatePresenterTaxesAndFees from "../RatePresenter/tabs/RatePresenterTaxesAndFees"
import RatePresenterChannels from "../RatePresenter/tabs/RatePresenterChannels"


class RateBuilderTabContent extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="tab-content">
        <RateBuilderGeneral {...this.props} />
        <RateBuilderBillingPolicy {...this.props} />
        <RateBuilderGuestTypes {...this.props} />
        <RateBuilderProducts {...this.props} />
        <RateBuilderSeasonalRates {...this.props} />
        <RateBuilderRoomTypes {...this.props} />
        <RatePresenterTaxesAndFees {...this.props} />
        <RatePresenterChannels {...this.props} />
      </div>
    );
  }

};

export default RateBuilderTabContent
